import { Component, Input } from '@angular/core';

export const CONFIRMATION_PDIALOG_KEY = 'confirmationDialogKey';

@Component( {
    selector: 'erp-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
} )

export class ConfirmationDialogComponent {
    @Input() width = 450;
    @Input() header = 'rm.erp.common.confirmation.delete';
    @Input() key = CONFIRMATION_PDIALOG_KEY;
}
